import { useMediaQuery, useTheme } from "@mui/material";

/** True below the "sm" breakpoint — used to render dialogs full-screen on phones. */
export const useIsMobile = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("sm"));
};
